/**
 * Helix 도메인 Query Hook Wrapper
 */

import {useQuery} from '@tanstack/react-query';
import {HELIX_QUERY_KEY_MAP} from '../api/helix/constant';
import {helixFactory} from '../factory/helixFactory';

// ============================================
// useHelixSeriesListQuery
// ============================================

export function useHelixSeriesListQuery(
  ...args: Parameters<typeof helixFactory.seriesList>
) {
  return useQuery(helixFactory.seriesList(...args));
}

useHelixSeriesListQuery.getKey = (
  ...args: Parameters<typeof HELIX_QUERY_KEY_MAP.seriesList>
) => [...HELIX_QUERY_KEY_MAP.seriesList(...args)];
